import { MusicAPIIntegrationID } from '../music-services/ids';

/**
 * The services a pre-save block offers when the artist picks none.
 *
 * Every service here must let musicapi save a track to the fan's library.
 * Shared by the wizard, the widget manager and the public page so all three
 * agree on the same list.
 */
export const defaultPresaveServices: string[] = [
  MusicAPIIntegrationID.Spotify,
  MusicAPIIntegrationID.AppleMusic,
  MusicAPIIntegrationID.Tidal,
  MusicAPIIntegrationID.Deezer,
  MusicAPIIntegrationID.AmazonMusic,
];

/**
 * The life of a campaign: it waits, then it either lands, runs out or is called
 * off. Only `scheduled` takes sign-ups; the other three close the block.
 *
 * Keep in sync with `PresaveCampaignStatus` in `music24-api/prisma/main/schema.prisma`.
 */
export enum PresaveCampaignStatus {
  scheduled = 'scheduled',
  released = 'released',
  expired = 'expired',
  cancelled = 'cancelled',
}
